module.exports = __webpack_public_path__ + "img/id.5b23062c.svg";